import React, { useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { getAllTransactions, transBulkActions } from '~/redux/actions/stripe-actions';
import { failure, success } from '~/redux/actions/snackbar-actions';

// Utils
import { MESSAGES } from '~/utils/message';
import { ExportModalIcon } from '~/assets/images';

// Components
import BalanceBoard from './BalanceBoard';
import PaymentMethodBoard from './PaymentMethodBoard';
import TransactionListing from './TransactionListing';
import ConfirmModal from '~/components/General/ConfirmModal';

import Stripe from '~/components//Stripe/Stripe';
import PaymentMethod from './PaymentMethod';
// MUI Components
import { Container, Typography, Box, Grid, GlobalStyles } from '@mui/material';

// styles
import './styles.scss';

const Wallet = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [openConfirmModal, setOpenConfirmModal] = useState({
    open: false,
    message: '',
    header: '',
    loading: false,
    handleOk: () => {},
    handleClose: () => {},
  });
  const [loading, setLoading] = useState(false);
  const [addFundsModal, setAddFundsModal] = useState(false);

  const dispatch = useDispatch();

  const exportUsers = async () => {
    try {
      setLoading(true);
      setOpenConfirmModal((prev) => ({ ...prev, loading: true }));
      const payload = {
        ids: selectedRows[0] === -1 ? -1 : selectedRows,
        action: 'export',
      };
      const response = await transBulkActions(payload);
      dispatch(getAllTransactions(1, 10));
      setSelectedRows([]);
      dispatch(success(response.data.message));
    } catch (error) {
      dispatch(failure(error?.response?.data?.message));
    } finally {
      setOpenConfirmModal((prev) => ({ ...prev, open: false, loading: false }));
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const handleExportClick = () => {
    const isMultiple = selectedRows[0] === -1 || selectedRows.length > 1;
    setOpenConfirmModal({
      open: true,
      message: isMultiple
        ? MESSAGES.ACCOUNT.WALLET.EXPORT.EXPORT_TRANS
        : MESSAGES.ACCOUNT.WALLET.EXPORT.EXPORT_SINGLE_TRANS,
      header: isMultiple
        ? MESSAGES.ACCOUNT.WALLET.EXPORT.MULTI_EXPORT_HEADER
        : MESSAGES.ACCOUNT.WALLET.EXPORT.SINGLE_EXPORT_HEADER,
      loading: false,
      handleOk: exportUsers,
      handleClose: () => setOpenConfirmModal((prev) => ({ ...prev, open: false })),
      type: 'export',
      successButtonName: 'Export',
      svg: <img src={ExportModalIcon} alt="export" />,
    });
  };

  return (
    <>
      <GlobalStyles styles={{ body: { backgroundColor: '#f9fafb' } }} />
      <Box className="olcWrapper">
        <Box className="olcPaymentCardMain">
          <Box className="olcHeaderWrap" style={{ marginBottom: '20px' }}>
            <Box>
              <Typography className="pageTitle">{MESSAGES.ACCOUNT.WALLET.TITLE}</Typography>
            </Box>
          </Box>
          <Box className="walletMainBoard">
            <BalanceBoard openPaymentMethodModal={() => setAddFundsModal(true)} />
            <PaymentMethodBoard openPaymentMethodModal={() => setAddFundsModal(true)} />
          </Box>

          <Box style={{ marginTop: '12px' }}>
            <TransactionListing
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              onExportClick={handleExportClick}
            />

            <ConfirmModal openConfirmModal={openConfirmModal} />
          </Box>
        </Box>
      </Box>
      <div style={{ position: 'absolute' }}>
        <Stripe>
          <PaymentMethod
            open={addFundsModal}
            handleOpen={() => {
              setAddFundsModal(true);
            }}
            handleClose={() => {
              setAddFundsModal(false);
            }}
          />
        </Stripe>
      </div>
    </>
  );
};

export default Wallet;
